/* TODO: t() */
import React, { ComponentProps, useRef } from 'react';
import Button from './Button';

import FilePicker from './FilePicker';

type Props = ComponentProps<typeof Button> & {
  id?: string;
  title?: string;
  children?: React.ReactNode;
  className?: string;
  multiple?: boolean;
  accept?: string;
  onFileSelect: (files: Array<File>) => void;
};

function FilePickerButton(props: Props) {
  let {
    title,
    children,
    multiple,
    accept,
    onFileSelect,
    id,
    ...otherProps
  } = props;
  let fileInputRef = useRef<HTMLInputElement>(null);
  let onPress = () => {
    fileInputRef.current && fileInputRef.current.click();
  };
  let testID = `form-file-input-${id}`;
  return (
    <Button {...otherProps} title={title} onPress={onPress}>
      {children}
      <FilePicker
        testID={id ? testID : undefined}
        innerRef={fileInputRef}
        title={title}
        onFileSelect={onFileSelect}
        multiple={multiple}
        accept={accept}
      />
    </Button>
  );
}

export default FilePickerButton;
